import { Box, Button } from "@mui/material";
import FormOptionCard, { FormOptionCardConfig } from "app/components/FormOptionCard";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { selectQuotationStandard95 } from "../../../redux/selector";
import { actions } from "../../../redux/slice";
import { AddOnItemFormValue, QuotationStandard95State } from "../../../types";
import { QUOTATION_FORM_I18N_PREFIX, QUOTATION_SECTION_KEYS } from "../data";
import { useStyles as useVehicleStyles } from "../VehicleDetails/styles";
import QuotationInputCard from "./QuotationInputCard";
import { useStyles } from "./styles";

type CardKey = keyof QuotationStandard95State;
const P = `${QUOTATION_FORM_I18N_PREFIX}.STANDARD_95`;
const tKey = (suffix: string) => `${P}.${suffix}`;

const STANDARD_95_CARDS: Record<CardKey, FormOptionCardConfig> = {
  sideGuardsReflectors: {
    titleKey: tKey("CARDS.SIDE_GUARDS_REFLECTORS"),
    fields: ["radio", "note"],
    radioLabelKey: tKey("FIELDS.TYPE"),
    notePlaceholderKey: tKey("FIELDS.NOTE"),
    radioOptions: [
      { value: "ALUMINUM", labelKey: tKey("OPTIONS.ALUMINUM") },
      { value: "IRON", labelKey: tKey("OPTIONS.IRON") },
    ],
  },
  sideLighting: {
    titleKey: tKey("CARDS.SIDE_LIGHTING"),
    fields: ["note"],
    notePlaceholderKey: tKey("FIELDS.NOTE"),
  },
  standardMudguards: {
    titleKey: tKey("CARDS.STANDARD_MUDGUARDS"),
    fields: ["note"],
    notePlaceholderKey: tKey("FIELDS.NOTE"),
  },
};

const Standard95Panel = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const standard95 = useSelector(selectQuotationStandard95);
  const styles = useStyles();
  const vehicleStyles = useVehicleStyles();
  if (!standard95) return null;

  const labels = {
    note: tKey("FIELDS.NOTE"),
    quantity: tKey("FIELDS.NOTE"),
    size: tKey("FIELDS.NOTE"),
    location: tKey("FIELDS.NOTE"),
    itemType: tKey("FIELDS.TYPE"),
  };
  const update = (key: CardKey, value: Partial<AddOnItemFormValue>) =>
    dispatch(actions.updateQuotationStandard95({ key, value }));
  const renderCard = (key: CardKey) => (
    <FormOptionCard
      key={key}
      config={STANDARD_95_CARDS[key]}
      value={standard95[key]}
      labels={labels}
      onChange={(v) => update(key, v)}
    />
  );

  return (
    <QuotationInputCard titleKey={QUOTATION_SECTION_KEYS.STANDARD_95}>
      <Box className={styles.grid3}>
        {renderCard("sideGuardsReflectors")}
        {renderCard("sideLighting")}
        {renderCard("standardMudguards")}
      </Box>
      <Box className={styles.actionRow}>
        <Button
          className={vehicleStyles.btn}
          variant="contained"
          color="primary"
          onClick={() => dispatch(actions.calculateQuotationPrice())}
        >
          {t(tKey("ACTIONS.CALCULATE_PRICE"))}
        </Button>
        <Button
          className={vehicleStyles.btn}
          variant="outlined"
          color="primary"
          onClick={() => dispatch(actions.resetQuotationStandard95())}
        >
          {t(tKey("ACTIONS.RESET"))}
        </Button>
      </Box>
    </QuotationInputCard>
  );
};

export default Standard95Panel;
